(function() {
'use strict';

angular
    .module('dashboard')
    .config(dashboardConfig);

function dashboardConfig($routeProvider,
                         dashboardEnabledConfig,
                         dashboardDisabledUrl,
                         dashboardDisabledReferenceUrl) {
    const dashboardEnabled = TRPCONFIG.Domain[dashboardEnabledConfig];

    const redirectTo = (url, ...params) => ({
        redirect: ['$window', '$route', ($window, $route) => $window.location = String.format(url, ...params.map(p => $route.current.params[p]))]
    });

    const amendResolver = {
        canAutoRebook: ['$http', '$location', '$route', function($http, $location, $route) {
            let params = $route.current.params;
            return $http.get('/api/bookings/amendments/options', {
                params: {
                    bookingId: params.BookingId,
                }
            })
            .then(({ data: { CanAutoRebook } }) => {
                if (!CanAutoRebook) {
                    $location.url(`desktop-url/${params.BookingRef}/${params.BookingId}/${params.LeadPassengerLastName}/amend`);
                    $location.replace();
                }
            });
        }],
        booking: ['dashboardBookingService', '$route', function(dashboardBookingService, $route) {
            return dashboardBookingService.getMybBooking($route.current.params.BookingId);
        }],
        bookedEstabId: ['dashboardBookingService', '$route', function(dashboardBookingService, $route) {
            return dashboardBookingService.getMybBooking($route.current.params.BookingId)
                .then(booking => _.get(booking, 'Itinerary.Stays[0].Hotel.EstabId'));
        }],
        hotel: ['hotelResolver', function(hotelResolver) {
            return hotelResolver.resolve(false);
        }],
    };

    $routeProvider.when('/dashboard/amend-booking/:BookingRef/:BookingId/:LeadPassengerLastName/start', {
        templateUrl: 'partials/dashboard/amendBooking',
        controller: 'AmendBooking',
        controllerAs: 'amend',
        area: 'hotels',
        resolve: _.pick(amendResolver, 'canAutoRebook', 'booking'),
    });

    $routeProvider.when('/dashboard/amend-booking/:BookingRef/:BookingId/:tripId', {
        templateUrl: 'partials/dashboard/amendBookingHotelSearch',
        controller: 'HotelSearch',
        controllerAs: 'cm',
        area: 'hotels',
        reloadOnSearch: false,
        breadcrumb: {
            crumb: 20
        }
    });

    $routeProvider.when('/dashboard/amend-booking/:BookingRef/:BookingId/:tripId/:estabId', {
        templateUrl: 'partials/dashboard/amendBookingAvailability',
        controller: 'HotelAvailability',
        controllerAs: 'cm',
        area: 'hotels',
        resolve: _.pick(amendResolver, 'hotel', 'bookedEstabId'),
    });

    if (!dashboardEnabled) {
        $routeProvider.when('/dashboard/booking-not-yours/:bookingId', {
            templateUrl: 'partials/dashboard/bookingnotyours',
            controllerAs: 'cm',
            controller($routeParams) {
                this.bookingNotYoursId = $routeParams.bookingId;
            }
        });
    }

    if (TRPCONFIG.Domain.DashboardHomeEnabled) {
        $routeProvider.when('/dashboard', {
            templateUrl: 'partials/dashboard/account',
            controllerAs: 'cm',
            controller: 'Dashboard',
            requiresHardAuth: true,
            requiresAnonAuth: false
        });
    }


    $routeProvider.when('/dashboard/bookings/:bookingPeriod', dashboardEnabled ? {
        templateUrl: $routeParams => `partials/dashboard/bookings?bookingType=${$routeParams.bookingPeriod}`,
        controllerAs: 'cm',
        controller: 'DashboardBookings',
        requiresHardAuth: true,
        requiresAnonAuth: false
    } : {
        requiresHardAuth: true,
        requiresAnonAuth: false,
        resolve: redirectTo(dashboardDisabledUrl)
    });

    $routeProvider.when('/dashboard/bookings/reference/:bookingId', dashboardEnabled ? {
        templateUrl: 'partials/dashboard/bookings?bookingType=reference',
        controller: 'DashboardBookings',
        controllerAs: 'cm',
        requiresAnonAuth: true,
        pixelTrackingPageName: 'dashboardBookingReference'
    } : {
        requiresAnonAuth: true,
        resolve: redirectTo(dashboardDisabledReferenceUrl)
    });

    if (TRPCONFIG.Domain.DashboardBookingEnabled || TRPCONFIG.Domain.DashboardMobileEnabled) {
        $routeProvider.when('/dashboard/bookings/', {
            redirectTo: '/dashboard/bookings/current'
        });

        $routeProvider.when('/dashboard/booking-details/:bookingId', {
            templateUrl: 'partials/dashboard/bookingdetails',
            controller: 'DashboardBookingDetails',
            pixelTrackingPageName: 'dashboardBookingDetails',
            controllerAs: 'cm',
            requiresAnonAuth: true,
            analyticsTag: 'Booking Details',
            hideSiteFooter: TRPCONFIG.Domain.MybHideFooter,
            hideFooterToolbar: TRPCONFIG.Domain.MybHideFooter,
            hideSiteMailingListSignUp: TRPCONFIG.Domain.MybHideFooter
        });

        $routeProvider.when('/dashboard/csr/:bookingId', {
            templateUrl: 'partials/dashboard/csr',
            controller: 'Csr',
            controllerAs: 'cm',
            requiresAnonAuth: true,
            hideSiteFooter: TRPCONFIG.Domain.MybHideFooter,
            hideFooterToolbar: TRPCONFIG.Domain.MybHideFooter,
            hideSiteMailingListSignUp: TRPCONFIG.Domain.MybHideFooter
        });

        $routeProvider.when('/dashboard/create-csr/:bookingId', {
            templateUrl: 'partials/dashboard/createcsr',
            controller: 'Csr',
            controllerAs: 'cm',
            requiresAnonAuth: true,
            hideSiteFooter: TRPCONFIG.Domain.MybHideFooter,
            hideFooterToolbar: TRPCONFIG.Domain.MybHideFooter,
            hideSiteMailingListSignUp: TRPCONFIG.Domain.MybHideFooter
        });

        $routeProvider.when('/dashboard/csr-details/:bookingId/:csrId', {
            templateUrl: 'partials/dashboard/csrdetails',
            controller: 'CsrDetails',
            controllerAs: 'cm',
            requiresAnonAuth: true,
            hideSiteFooter: TRPCONFIG.Domain.MybHideFooter,
            hideFooterToolbar: TRPCONFIG.Domain.MybHideFooter,
            hideSiteMailingListSignUp: TRPCONFIG.Domain.MybHideFooter
        });

        $routeProvider.when('/dashboard/resend-voucher/:bookingId', {
            templateUrl: 'partials/dashboard/resendvoucher',
            controller: 'ResendVoucher',
            controllerAs: 'cm',
            requiresAnonAuth: true,
            hideSiteFooter: TRPCONFIG.Domain.MybHideFooter,
            hideFooterToolbar: TRPCONFIG.Domain.MybHideFooter,
            hideSiteMailingListSignUp: TRPCONFIG.Domain.MybHideFooter
        });
        $routeProvider.when('/dashboard/contact-detail/:bookingId', {
            templateUrl: 'partials/dashboard/contactdetail',
            controller: 'ContactDetail',
            controllerAs: 'cm',
            requiresAnonAuth: true,
            hideSiteFooter: TRPCONFIG.Domain.MybHideFooter,
            hideFooterToolbar: TRPCONFIG.Domain.MybHideFooter,
            hideSiteMailingListSignUp: TRPCONFIG.Domain.MybHideFooter
        });


        $routeProvider.when('/dashboard/pay-balance/:bookingId', dashboardEnabled && TRPCONFIG.Domain.PaybalanceV2Enabled ? {
            templateUrl: 'partials/dashboard/paybalance',
            controller: 'PayBalance',
            controllerAs: 'cm',
            requiresAnonAuth: true,
            analyticsTag: 'Pay Balance',
            pixelTrackingPageName: 'dashboardPayBalance',
            hideSiteFooter: TRPCONFIG.Domain.MybHideFooter,
            hideFooterToolbar: TRPCONFIG.Domain.MybHideFooter
        } : {
            requiresAnonAuth: true,
            resolve: redirectTo('/manage-your-booking/make-a-payment.aspx?BID={0}', 'bookingId')
        });

        if (TRPCONFIG.Domain.PaybalanceV2Enabled) {
            $routeProvider.when('/dashboard/pay-balance/complete/:bookingId', {
                templateUrl: 'partials/dashboard/paybalancecomplete',
                controller: 'PayBalanceComplete',
                controllerAs: 'cm',
                requiresAnonAuth: true,
                hideSiteFooter: TRPCONFIG.Domain.MybHideFooter,
                hideFooterToolbar: TRPCONFIG.Domain.MybHideFooter
            });
        }
    }

    if (TRPCONFIG.Domain.DashboardReviewsEnabled) {
        $routeProvider.when('/dashboard/reviews', {
            templateUrl: 'partials/dashboard/myreview',
            controllerAs: 'cm',
            controller: 'DashboardReview',
            requiresHardAuth: false,
            requiresAnonAuth: true,
            resolve: {
                redirect: ['authService', '$location', (authService, $location) => {
                    const user = authService.getUser();
                    const bookingId = _.get(user, 'BookingId') || _.get(user, 'Contact.BookingId');
                    if (user.AnonSignedIn && bookingId) {
                        $location.path(`review-hotel/${bookingId}`);
                    }
                }],
                action: () => 'get-reviews'
            }
        });

        $routeProvider.when('/dashboard/reviews/submitted/:bookingId/:objectId?', {
            templateUrl: 'partials/dashboard/reviewsubmitted',
            controllerAs: 'cm',
            controller: 'DashboardReview',
            requiresHardAuth: true,
            requiresAnonAuth: true,
            resolve: {
                action: () => 'review-submitted'
            }
        });
        $routeProvider.when('/dashboard/feedbackform/:bookingId/:objectId?', {
            templateUrl: 'partials/dashboard/feedbackform',
            controllerAs: 'cm',
            controller: 'DashboardReview',
            requiresHardAuth: false,
            requiresAnonAuth: true,
            resolve: {
                action: () => 'review-hotel'
            }
        });

        $routeProvider.when('/dashboard/review-hotel/:bookingId/:userId/:token', {
            templateUrl: 'partials/dashboard/feedbackform',
            controllerAs: 'cm',
            controller: 'DashboardReview',
            requiresHardAuth: false,
            requiresAnonAuth: false,
            resolve: {
                action: () => 'review-hotel'
            }
        });
    }

    if (TRPCONFIG.Domain.DashboardSettingsEnabled) {
        $routeProvider.when('/dashboard/settings', {
            templateUrl: 'partials/dashboard/settings',
            controllerAs: 'cm',
            controller: 'DashboardSettings',
            requiresHardAuth: true,
            requiresAnonAuth: false
        });
    }

    if (TRPCONFIG.Domain.DashboardBookingEnabled || TRPCONFIG.Domain.DashboardMobileEnabled) {
        //to redirect to old desktop urls.
        $routeProvider
            .when('/desktop-url/:SID/:BID/:SN/:NAV/:CSRID?', {
                template: '<div></div>',
                controller: ['v1Redirection', '$routeParams', (v1Redirection, $routeParams) => v1Redirection.v1Redirect($routeParams)]
            });

        $routeProvider.when('/dashboard/support', {
            templateUrl: 'partials/dashboard/dashboardsupport',
            controller: 'Csr',
            controllerAs: 'cm',
            requiresAnonAuth: true
        });
    }
    if (TRPCONFIG.Domain.FlightCheckinEnabled) {
        $routeProvider.when('/dashboard/online-checkin/:bookingId', {
            templateUrl: 'partials/dashboard/onlinecheckin',
            controller: 'OnlineCheckin',
            controllerAs: 'cm',
            requiresHardAuth: true,
            requiresAnonAuth: false
        });
    }

    if (TRPCONFIG.Domain.DashboardAddBagsEnabled) {
        $routeProvider.when('/dashboard/add-baggage/:bookingId', {
            templateUrl: 'partials/dashboard/addbaggage',
            controller: 'AddBaggage',
            controllerAs: 'cm',
            requiresAnonAuth: true,
            hideSiteFooter: TRPCONFIG.Domain.MybHideFooter
        });

        $routeProvider.when('/dashboard/add-baggage/complete/:bookingId', {
            templateUrl: 'partials/dashboard/addbaggagecomplete',
            requiresAnonAuth: true,
            controller: 'PayBalanceComplete',
            controllerAs: 'cm',
            hideSiteFooter: TRPCONFIG.Domain.MybHideFooter
        });
    }

    if (TRPCONFIG.Domain.DashboardAddSeatsEnabled) {
        $routeProvider.when('/dashboard/seat-selection/:bookingId', {
            templateUrl: 'partials/dashboard/dashboardseatselection',
            controller: 'DashboardSeatSelection',
            controllerAs: 'cm',
            requiresAnonAuth: true,
            hideSiteFooter: TRPCONFIG.Domain.MybHideFooter
        });

        $routeProvider.when('/dashboard/seat-selection/complete/:bookingId', {
            templateUrl: 'partials/dashboard/addseatscomplete',
            requiresAnonAuth: true,
            controller: 'PayBalanceComplete',
            controllerAs: 'cm',
            hideSiteFooter: TRPCONFIG.Domain.MybHideFooter
        });
    }

    if (TRPCONFIG.Domain.DashboardAddAPIEnabled) {
        $routeProvider.when('/dashboard/add-api/:bookingId', {
            templateUrl: 'partials/dashboard/addapi',
            requiresAnonAuth: true,
            controller: 'AddAPI',
            controllerAs: 'cm',
            hideSiteFooter: TRPCONFIG.Domain.MybHideFooter
        });
    }
}
})();
